<template>
    <div class="app-container">
      <div class="top-box">
        <vxe-button status="primary" v-auth="`ADD`" @click="addAddress" style="margin-bottom:10px">添加地址</vxe-button>
        <div>
          <div class="search-box">
            <div>
                <span>收货人</span>
                <a-input v-model="serachParams.name" style="width:130px" clearable placeholder="请输入关键字搜索"/>
            </div>
            <div>
              <span>电话</span>
              <a-input v-model="serachParams.phone" style="width:130px" clearable placeholder="请输入关键字搜索" />
            </div>
            <div>
                <span>地址</span>
                <a-input v-model="serachParams.address" style="width:130px" clearable placeholder="请输入关键字搜索"/>
            </div>
            <!-- <div>
                <span>地区</span>
                <a-input v-model="serachParams.region" style="width:130px" clearable placeholder="请输入关键字搜索"/>
            </div> -->
            <div>
                <span>创建人</span>
                <a-input v-model="serachParams.createUser" style="width:130px" clearable placeholder="请输入关键字搜索"/>
            </div>
            <div style="margin-left:10px">
              <vxe-button status="primary" @click="getList">搜索</vxe-button>
              <vxe-button @click="resetSearch">重置</vxe-button>
            </div>
          </div>
          
        </div>
      </div>
      <vxe-table
        ref="xTable"
        :loading="listLoading"
        align="center"
        :max-height="$store.state.app.height - 130 < 360 ? 360 : $store.state.app.height - 130"
        border
        show-header-overflow
        show-overflow
        class="mytable-scrollbar"
        :column-config="{ resizable: true }"
        stripe
        round
        :scroll-y="{ enabled: false }"
        :row-config="{ isHover: true }"
        :data="addresses"
        >
        <!-- <vxe-column type="checkbox" width="60" align="center" /> -->
        <vxe-column :field="item.key" :title="item.title" :width="item.width" v-for="item in columns" :key="item.key"></vxe-column>
        <!-- <vxe-column title="默认地址" width="150">
            <template #default="{ row }">
              <a-tag v-if="row.isDefault" color="blue">默认</a-tag>
              <a-radio
                :label="row.isDefault"
                :checked="Boolean(row.isDefault)"
                v-else
                @change="setDefaultAddress(row)"
              >设为默认地址</a-radio>
            </template>
        </vxe-column> -->

        <vxe-column title="创建人" width="200">
          <template #default="{ row }">
            <div>{{row.userNo}}</div>
            <!-- <a-tag v-if="row.isDefault" color="blue">默认</a-tag>
            <a-radio
              :label="row.isDefault"
              :checked="Boolean(row.isDefault)"
              v-else
              @change="setDefaultAddress(row)"
            >设为默认地址</a-radio> -->
          </template>
      </vxe-column>

        
        <vxe-column title="操作" width="200">
            <template #default="{ row }">
                <a-button type="link" v-auth="`UPDATE`" @click="editAddress(row)">编辑</a-button>
                <a-button type="link" v-auth="`DELETE`" @click="deleteAddress(row.id)">删除</a-button>
            </template>
        </vxe-column>
      </vxe-table>
      <vxe-pager
        :current-page="serachParams.pageNum"
        :page-size="serachParams.pageSize"
        :total="total"
        :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
        @page-change="changePage"
        />
        <address-modal ref="addressModalRef" @updateList="getList" />
    </div>
  </template>
  
  <script>
  import AddressModal from './components/AddressModal.vue' 
  import { getAddressList, setDefaultAddress, deleteAddressList } from '@/api/material.js'
  export default {
    components:{ AddressModal },
    data() {
      return {
        listLoading: false,
        addresses: [],
        columns: [
          { title: '收货人', dataIndex: 'name', key: 'recipientName', width: '150px' },
          { title: '电话', dataIndex: 'phone', key: 'contactPhone' ,width: '150px'},
          // { title: '所在地区', dataIndex: 'area', key: 'region', width: '150px'},
          { title: '详细地址', dataIndex: 'address', key: 'detailedAddress' ,width: '500px' },
        ],
        addressModalRef: null,
        total: 0,
        serachParams: {
          pageNum :1,
          pageSize :10,
          name :"",
          address :"",
          phone: '',
          region: '',
          createUser: ''
        },
        editData:{}
      };
    },
    created() {
      this.getList()
    },
    methods: {
       async getList() {
         const res = await getAddressList(this.serachParams)
         this.addresses = res.data.list
         this.total = res.data.total
       },
      async setDefaultAddress(row) {
         const res = await setDefaultAddress(
          {
            id: row.id,
            phone: row.contactPhone
          }
         )
         if (res.code === 1) {
            this.$message.success('设置成功')
            this.getList()
         } else {
            this.$message.error('设置失败')
         }
       },
        changePage({ currentPage, pageSize }) {
            this.serachParams.pageNum = currentPage
            if (pageSize != this.serachParams.pageSize) this.serachParams.pageNum = 1
            this.serachParams.pageSize = pageSize
            this.getList()
        },
        addAddress() {
            // 显示添加地址的对话框
            this.$refs.addressModalRef.showAddModal()
        },
        editAddress(address) {
            // 编辑地址
            this.editData = address
            this.$refs.addressModalRef.showAddModal(address)
        },
        async deleteAddress(id) {
          this.$confirm({
          title: '确定要删除地址吗',
          content: '',
          onOk: async() => {
            // 删除地址
            const res = await deleteAddressList(id)
            if (res.code === 1) {
              this.$message.success('删除成功')
              this.getList()
            } else {
                this.$message.error('删除失败')
            }
          },
          onCancel() {
            // console.log('Cancel');
            }
          });
        },
        resetSearch() {
          this.serachParams.name = ''
          this.serachParams.address = ''
          this.serachParams.phone = ''
          this.serachParams.region = ''
          this.serachParams.createUser = ''
          this.getList()
        }
    },
  };
  </script>
  <style  lang="less" scoped>
    .top-box {
      display: flex;
      justify-content: end;
      align-items: center;
      .search-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        div {
          display: flex;
          align-items: center;
          span {
            display: inline-block;
            width: 70px;
            text-align: right;
            padding-right: 10px;
          }
        }
      }
    }
   
  </style>
  